<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="card-header-title">
                   <span class="mdi mdi-image-multiple-outline text-muted mr-2"></span> Media
                </div>
            </div>

            <div class="card-body">
                <div v-if="media && viewState == 'Idle'">                   
                    <ul class="media-list">
                        <li v-for="item in media" :key="item.media_id">
                            <img :src="item.thumbnail_access_url || item.access_url" :class="!item.include_in_report ? 'exclude-from-report' : ''" alt="">
                            <br>
                            <div class="mt-1">
                                <!-- include in report? -->
                                <button class="btn btn-success" v-if="item.include_in_report" @click="setMediaItemIncluded(item, false)">
                                    <span class="mdi mdi-radiobox-marked mr-0"></span>
                                </button>
                                <button class="btn btn-secondary" v-if="!item.include_in_report" @click="setMediaItemIncluded(item, true)">
                                    <span class="mdi mdi-radiobox-blank mr-0"></span>
                                </button>

                                <button class="btn btn-sm btn-primary ml-1" v-if="item.include_in_report" @click="editMediaItem(item)">
                                    <span class="mdi mdi-playlist-edit"></span> EDIT
                                </button>
                                <button class="btn btn-sm btn-primary ml-1" v-if="item.include_in_report" @click="setCover(item)" :disabled="isSettingCover">
                                    <span class="mdi mdi-page-layout-header-footer"></span> SET COVER
                                </button>
                            </div>
                        </li> 
                    </ul>
                </div>

                <div class="text-center" v-if="media && media.length == 0">
                    <span class="mdi mdi-image-multiple-outline text-muted" style="font-size: 3em; opacity: 0.5;"></span>
                    <h5 class="text-muted mb-3">No Media added to this section</h5>
                </div>

                <LoadingIndicator v-if="viewState == 'Busy'" />
                <ErrorMessage v-if="viewState == 'Error'" />
            </div>
        </div>

        <!-- Edit details modal -->
        <b-modal
            id="modal-edit-media"
            title="Edit Image Details"
            ok-title="Save"
            @ok="onEditMediaOK">
            <div>
                <img :src="mediaItemInEdit.access_url" class="img-fluid mb-2">

                <div class="form-group">
                    <label for="title">Title</label>
                    <input type="text" class="form-control" v-model="mediaItemInEdit.title">
                </div>

                <div class="form-group">
                    <label for="title">Description</label>
                    <textarea class="form-control" rows="5" v-model="mediaItemInEdit.description"></textarea>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import ReportService from '../../services/reports/reportService'

    export default {
        props: {
            sectionNumber: String
        },
        data() {
            return {
                viewState: 'Idle',
                jobReference: this.$route.params.jobReference,
                error: null,
                media: null,
                isSettingCover: false,
                mediaItemInEdit: {}
            }
        },
        async mounted() {
            this.viewState = 'Busy'
            try {
                let sectionNumber = this.sectionNumber
                this.media = await ReportService.getReportSectionMedia(this.jobReference, sectionNumber)
                this.viewState = 'Idle'

            } catch (err) {
                console.error('Error loading report', err)
                this.viewState = 'Error'
                this.error = err
            }
        },
        methods: {
            getThumbnailIfAvailable(mediaItem) {
                return mediaItem.has_thumbnail ? mediaItem.thumbnail_access_url : mediaItem.access_url
            },
            async setCover(mediaItem) {
                try {
                    this.isSettingCover = true
                    await ReportService.updateReportHeader(this.jobReference, {
                        cover_media_id: mediaItem.media_id
                    })

                    this.$bvToast.toast('Cover image set', {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                } catch (err) {                    
                    console.error(err)
                    this.$bvToast.toast('Sorry, something went wrong and the cover image could not be updated', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }

                this.isSettingCover = false
            },
            editMediaItem(mediaItem) {
                this.mediaItemInEdit = mediaItem
                this.$bvModal.show('modal-edit-media')
            },
            async onEditMediaOK(bvEvt) {
                try {
                    this.$bvToast.toast(`Saving Media Details...`, {
                        title: 'Saving',
                        variant: 'warning',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 2000
                    })

                    let mediaId = this.mediaItemInEdit.media_id
                    let updates = {
                        title: this.mediaItemInEdit.title,
                        description: this.mediaItemInEdit.description
                    }

                    
                    await ReportService.updateMediaItem(this.jobReference, this.sectionNumber, mediaId, updates)
                    let arrIndex = this.$_.findIndex(this.media, m => m.media_id == mediaId)
                    this.media[arrIndex] = this.mediaItemInEdit
                    this.mediaItemInEdit = {}

                    this.$bvToast.toast(`Media Details Saved`, {
                        title: 'Saved',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 2000
                    })

                } catch (error) {
                    console.error(error)
                    let status = error.response && error.response.status || ''
                    this.$bvModal.msgBoxOk(`An error occurred while saving your media (${status})`, {
                        title: 'Save Error',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    })
                }
            },
            async setMediaItemIncluded(mediaItem, isIncluded) {
                let arrIndex = this.$_.findIndex(this.media, m => m.media_id == mediaItem.media_id)
                if (arrIndex == -1)
                {
                    console.log('arrIndex == -1')
                    return;
                }

                let startState = this.media[arrIndex].include_in_report
                this.media[arrIndex].include_in_report = isIncluded
                    
                try {
                    await ReportService.updateMediaItem(this.jobReference, this.sectionNumber, mediaItem.media_id, {
                        include_in_report: isIncluded
                    })

                } catch (error) {
                    this.media[arrIndex].include_in_report = startState

                    console.error(error)
                    let status = error.response && error.response.status || ''
                    this.$bvModal.msgBoxOk(`An error occurred while saving your media (${status})`, {
                        title: 'Save Error',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    })
                }
            }
        }
    }
</script>

<style lang="scss">
    img.exclude-from-report {
        opacity: 0.3;
    }
    ul.media-list {
        list-style: none;
        padding-left: 0;

        li {
            float: left;
            margin-right: 1em;
            padding: 6px;
            background: #f5f5f5;
            text-align: right;
            margin-bottom: 0.8rem;

            img {
                max-height: 200px;
                max-width: 100%;
            }

            button {
                padding: 2px 4px;
                font-size: 0.9em;
            }
        }
    }

    ul.media-list li .btn-delete-img {
      color: #d2363c;
      font-size: 1.4em;
      padding: 0;
      background: transparent;
    }

    ul.media-list li .btn-delete-img:active,
    ul.media-list li .btn-delete-img:focus {
        background-color: transparent;
        box-shadow: none;
        color: #d9797d;
    }

    ul.media-list li .btn-delete-img .fa {
        margin-right: 0;
        margin-top: 6px;
    }

    ul.media-list li .btn-add-img {
      height: 100px;
      max-height: 100px;
      background: transparent;
    }

    ul.media-list li .btn-add-img .fa {
        font-size: 4em;
        margin-bottom: 8px;
        color: lightgrey;
    }

    ul.media-list li .btn-add-img:active,
    ul.media-list li .btn-add-img:focus {
        background-color: transparent;
        box-shadow: none;
    }
</style>